export default __webpack_public_path__ + "static/media/createBrand-icon.cda0ed5a.svg";